// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, all, putResolve, select } from 'redux-saga/effects';
import { getModuleX } from '@tcp/core/src/services/abstractors/common/moduleXComposite';
import { getAPIConfig, getBrand } from '@tcp/core/src/utils';
import { validateReduxCache } from '@tcp/core/src/utils/cache.util';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  getCurrentStoreInfoApi,
  getLocationStoresMapbox,
} from '@tcp/core/src/services/abstractors/common/storeLocator';
import { getStoreLocatorMapboxTileIDs } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import constants from './StoreDetail.constants';
import {
  setCurrentStoreInfo,
  setNearByStore,
  setModuleXContent,
  setStoreDetailLoadingState,
  setNearByStoreLoading,
  fetchProductsSuccess,
  fetchProductsFailure,
} from './StoreDetail.actions';
import fetchProducts from './storeSpecialProducts';

export function* getMapboxTileIDs() {
  return yield select(getStoreLocatorMapboxTileIDs);
}

export function* getCurrentStore({ payload: { storeID, resolve, apiConfig: config } }) {
  try {
    const apiConfig = config || getAPIConfig();
    const { brandIdCMS } = apiConfig;
    yield put(setStoreDetailLoadingState(true));
    // Country check is not required for store search hence sending empty string.
    const country = '';
    const res = yield call(getCurrentStoreInfoApi.getData, brandIdCMS, country, storeID, apiConfig);
    if (resolve) {
      resolve();
    }
    yield put(setStoreDetailLoadingState(false));
    return yield putResolve(setCurrentStoreInfo(res));
  } catch (err) {
    if (resolve) {
      resolve();
    }
    yield put(setStoreDetailLoadingState(false));
    return yield null;
  }
}

export function* getNearByStore({ payload }) {
  try {
    const payloadCopy = { ...payload, storeLocatorMapboxTileIDs: yield call(getMapboxTileIDs) };
    yield put(setNearByStoreLoading(true));
    const response = yield call(getLocationStoresMapbox, payloadCopy);
    yield put(setNearByStoreLoading(false));
    return yield put(setNearByStore({ nearByStores: response }));
  } catch (err) {
    return yield null;
  }
}

export function* fetchModuleX({ payload = [] }) {
  try {
    const moduleXResponses = yield call(getModuleX, payload);
    const putDescriptorParams = Object.keys(moduleXResponses).map((item) => ({
      key: item,
      value: moduleXResponses[item],
    }));
    return yield all([
      put(setModuleXContent(putDescriptorParams[0])),
      put(setModuleXContent(putDescriptorParams[1])),
      put(setModuleXContent(putDescriptorParams[2])),
      put(setModuleXContent(putDescriptorParams[3])),
    ]);
  } catch (err) {
    return yield null;
  }
}

// Saga function to handle fetching products
function* fetchProductsSaga({ payload }) {
  try {
    const { store } = payload;
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const apiConfig = getAPIConfig();
    const brand = getBrand();
    const response = yield call(fetchProducts, {
      xappURLConfig,
      facetsPayload: {},
      apiConfig,
      brand,
      store,
    });

    // Dispatch success action with the response data
    yield put(fetchProductsSuccess(response?.response?.products));
  } catch (error) {
    // Log the error
    logger.error({
      error: `Error in fetchProductsSaga: ${error.message}`,
      extraData: {
        componentName: 'ProductSaga',
        methodName: 'fetchProductsSaga',
        actionPayload: payload,
      },
    });

    // Dispatch failure action with the error
    yield put(fetchProductsFailure(error));
  }
}

export function* StoreDetailSaga() {
  const cachedModuleX = validateReduxCache(fetchModuleX);
  yield takeLatest(constants.GET_CURRENT_STORE, getCurrentStore);
  yield takeLatest(constants.GET_SUGGESTED_STORE, getNearByStore);
  yield takeLatest(constants.GET_MODULEX_CONTENT, cachedModuleX);
  yield takeLatest(constants.FETCH_PRODUCTS_REQUEST, fetchProductsSaga);
}

export default StoreDetailSaga;
